import { addDays, addMonths, addWeeks, endOfDay, endOfMonth, endOfWeek, isBefore, isSameDay, isSameMonth, isValid, isWithinInterval, max, min, parseJSON, startOfDay, startOfMonth, startOfWeek, } from 'date-fns';
export const chunks = (array, size) => {
    return Array.from({ length: Math.ceil(array.length / size) }, (v, i) => array.slice(i * size, i * size + size));
};
export const getDaysInMonth = (date, weekStartsOn) => {
    const startWeek = startOfWeek(startOfMonth(date), { weekStartsOn });
    const endWeek = endOfWeek(endOfMonth(date), { weekStartsOn });
    const days = [];
    for (let curr = startWeek; isBefore(curr, endWeek);) {
        days.push(curr);
        curr = addDays(curr, 1);
    }
    return days;
};
export const isStartOfRange = ({ startDate }, day) => (startDate && isSameDay(day, startDate));
export const isEndOfRange = ({ endDate }, day) => (endDate && isSameDay(day, endDate));
export const inDateRange = ({ startDate: start, endDate: end }, day) => (start && end && (isWithinInterval(day, { start, end }) || isSameDay(day, start) || isSameDay(day, end)));
export const isRangeSameDay = ({ startDate, endDate }) => {
    if (startDate && endDate) {
        return isSameDay(startDate, endDate);
    }
    return false;
};
export const parseOptionalDate = (date, defaultValue) => {
    if (date) {
        const parsed = parseJSON(date);
        if (isValid(parsed)) {
            return parsed;
        }
    }
    return defaultValue;
};
export const generateYears = (relativeTo, count) => {
    const half = Math.floor(count / 2);
    return Array(count)
        .fill(0)
        .map((y, i) => relativeTo.getFullYear() - half + i);
};
export const getDefaultRanges = (date) => [
    {
        labelKey: 'today',
        startDate: startOfDay(date),
        endDate: endOfDay(date),
    },
    {
        labelKey: 'yesterday',
        startDate: startOfDay(addDays(date, -1)),
        endDate: endOfDay(addDays(date, -1)),
    },
    {
        labelKey: 'last_week',
        startDate: startOfDay(startOfWeek(addWeeks(date, -1))),
        endDate: endOfDay(endOfWeek(addWeeks(date, -1))),
    },
    {
        labelKey: 'last_month',
        startDate: startOfDay(startOfMonth(addMonths(date, -1))),
        endDate: endOfDay(endOfMonth(addMonths(date, -1))),
    },
];
export const getValidatedMonths = (range, minimumDate, maximumDate) => {
    const { startDate, endDate } = range;
    if (startDate && endDate) {
        const newStart = max([startDate, minimumDate]);
        const newEnd = min([endDate, maximumDate]);
        return [newStart, isSameMonth(newStart, newEnd) ? addMonths(newStart, 0) : newEnd];
    }
    else {
        return [startDate, endDate];
    }
};
//# sourceMappingURL=utils.js.map